import { AiOutlineLoading3Quarters } from "react-icons/ai";
import React from "react";
import { twMerge } from "tailwind-merge";

type FullPageSpinnerProps = Partial<{
  classNames: Partial<{
    icon: string;
    container: string;
  }>;
}>;

export const FullPageSpinner = ({
  classNames,
}: FullPageSpinnerProps): React.ReactElement => (
  <div
    className={twMerge(
      "flex h-screen w-screen items-center justify-center bg-black",
      classNames?.container
    )}
  >
    <AiOutlineLoading3Quarters
      className={twMerge(
        "text-primary-300 h-20 w-20 animate-spin text-white",
        classNames?.icon
      )}
    />
  </div>
);
